import { createZodDto } from "nestjs-zod/dto";
import { z } from "zod";

export const atsScoreSchema = z.object({
  resume: z.string().min(50).max(8000),
  jobDescription: z.string().min(50).max(8000),
});

export class AtsScoreDto extends createZodDto(atsScoreSchema) {}

export const atsScoreResultSchema = z.object({
  matchPercentage: z.number().int().min(0).max(100),
  matchedKeywords: z.array(z.string()),
  missingKeywords: z.array(z.string()),
  suggestions: z.array(z.string()).length(3),
});

export type AtsScoreResult = z.infer<typeof atsScoreResultSchema>;

export const atsScoreResponseSchema = atsScoreResultSchema.extend({
  cached: z.boolean(),
});

export class AtsScoreResponseDto extends createZodDto(atsScoreResponseSchema) {}

export type AtsScoreResponse = z.infer<typeof atsScoreResponseSchema>;
